import useSWR from "swr";
import { getAvailableRoutines } from "../services/template-service";
import type {
  AvailableRoutinesResponse,
  AvailableRoutineItem,
} from "../types/api-types";

export interface UseAvailableRoutinesReturn {
  availableRoutines: AvailableRoutineItem[] | undefined;
  isLoading: boolean;
  // SWR returns any, so a more explicit type cannot be used
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  mutate: () => void;
}

const useAvailableRoutines = (): UseAvailableRoutinesReturn => {
  const { data, error, isLoading, mutate } = useSWR<AvailableRoutinesResponse>(
    "available-routines",
    () => getAvailableRoutines(),
  );

  return {
    availableRoutines: data?.results,
    isLoading,
    error,
    mutate,
  };
};

export default useAvailableRoutines;
